import { ArrowRight, Hourglass } from "lucide-react";
import { Button, Card } from "@/components/ui/primitives";

export function StageNotReached({
  title,
  description,
  primaryLabel,
  onPrimary,
  primaryDisabled,
}: {
  title: string;
  description: string;
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
}) {
  return (
    <Card className="p-10 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-muted">
        <Hourglass className="h-6 w-6 text-muted-foreground" strokeWidth={1.7} />
      </div>
      <h3 className="mt-4 text-lg font-semibold">{title}</h3>
      <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">{description}</p>
      <Button className="mt-6" variant="brand" size="lg" onClick={onPrimary} disabled={primaryDisabled}>
        {primaryLabel} <ArrowRight className="h-4 w-4" strokeWidth={2.2} />
      </Button>
    </Card>
  );
}
